<template>
  <div class="home-header" v-if="userInfo.ext_info">
    <div class="header-container">
      <div class="navigation-system" @mouseenter="navtracer()">
        <div class="horizontal-line" v-for="i in 3" :key="i"></div>
        <AllSysytem class="all-system" :style="{height:autoHeight}" />
      </div>
      <router-link to="/" class="title">云杉林-企业内网门户</router-link>
      <ul class="nav">
        <li>
        </li>
        <li>
        </li>
        <li>
        </li>
      </ul>
      <div class="search-container" ref="searchArea" v-clickoutside="handleClose">

      </div>
      <div class="user">
        <div class="user-show">
          <img
            :src="userInfo.ext_info.avatars[1]"
            width="40"
            v-if="userInfo.ext_info.avatars.length>0"
          />
          <div class="avatar-40" v-else>{{userInfo.name.substring(userInfo.name.length-2)}}</div>
          {{userInfo.name}}
          <i class="el-icon-arrow-down"></i>
        </div>
        <div class="toolBar">
          <div class="user-info">
            <img
              :src="userInfo.ext_info.avatars[2]"
              width="60"
              v-if="userInfo.ext_info.avatars.length>0"
            />
            <div class="avatar-60" v-else>{{userInfo.name.substring(userInfo.name.length-2)}}</div>
            <div class="user-title">
              <h3>{{userInfo.name}}</h3>
              <p
                v-if="userInfo.cas_info&&userInfo.cas_info.deptpath"
              >{{userInfo.cas_info.deptpath.split('|').join('-')}} {{userInfo.cas_info.postname}}</p>
            </div>
          </div>
          <div class="operation-list">
            <router-link to="/personal">个人中心</router-link>
            <a :href="pathConfig.retrievePath">重置密码</a>
            <a :href="pathConfig.loginPath">退出</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AllSysytem from "./system.vue";
import pathConfig from "@/config/requirePath";
import { mapGetters } from "vuex";
export default {
  name: "HomeHeader",
  components: {
    AllSysytem
  },
  data() {
    return {
      content: "",
      showToolBar: false,
      dialogVisbility: false,
      resultList: [],
      prompt: true,
      loginOut: "",
      pathConfig,
      autoHeight: "",
      searchResultWeight: {
        系统: 1,
        人员: 2,
        文档: 3,
        待办: 4
      }
    };
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  methods: {
    handleClose() {
      this.prompt = false;
    },
    search() {
      //
    },
    handleSearch() {
      thin.$router.push("/");
    },
    jump() {
      mcTracer.click("n.3386.6033.0", {
        keyword: this.content
      });
      this.prompt = false;
      this.content
        ? this.$router.push({
            name: "search-result",
            params: { key: this.content }
          })
        : "";
    },
    trace(content, resultList) {
      mcTracer.click("n.3386.6033.0", {
        keyword: content
      });
      if (resultList.title === "人员") {
        // resultList.items.length >6 跳查看更多搜索结果页 否认跳搜索结果也
        const params = { key: this.content };
        if (resultList.items.length > 6) {
          params.type = "user";
        }
        this.$router.push({
          name: resultList.items.length > 6 ? "result-more" : "search-result",
          params
        });
      }
    },
    navtracer() {
      mcTracer.click("n.3386.6031.0");
    },
    getAutoHeight() {
      let _w =
        document.documentElement.clientHeight || document.body.clientHeight;
      this.autoHeight = _w - 66 + "px";
    }
  },

  mounted() {
    this.getAutoHeight();
  },
  watch: {
    content() {
      this.prompt = true;
      if (this.content) {
        this.search();
      } else {
        this.resultList = [];
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/mixin.scss";
.router-link-active {
  opacity: 1;
  font-weight: 900;
}
a {
  color: #fff;
}
.home-header {
  height: 64px;
  line-height: 64px;
  background-color: #1890ff;
  font-size: 14px;
  .header-container {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    align-items: center;
    color: #fff;
    .title {
      font-size: 18px;
      font-family: PingFangSC-Medium;
      margin: 0 192px 0 20px;
    }
    .navigation-system {
      position: relative;
      width: 64px;
      height: 100%;
      padding: 23px;
      background-color: #46a6ff;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .all-system {
        display: none;
        position: absolute;
        top: 64px;
        left: 0;
        z-index: 99;
        width: 1200px;
        height: 680px;
        opacity: 0.95;
        border-radius: 3px;
        background-color: rgba(255, 255, 255, 1);
        box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.2);
      }
      &:hover .all-system {
        display: block;
      }
      .horizontal-line {
        width: 18px;
        height: 2px;
        background-color: #fff;
      }
    }
  }
  .search-container {
    position: relative;
    margin: 0 20px;
    width: 270px;
  }
  .nav {
    display: flex;
    .navigation {
      opacity: 0.8;
      cursor: pointer;
      position: relative;
    }
    li {
      width: 90px;
      text-align: center;
      margin-right: 15px;
      a {
        opacity: 0.8;
      }
      &:hover {
        color: #4272ab;
      }
      &:hover a {
        color: #4272ab;
      }
    }
  }
  .search-container {
    .search-input /deep/ {
      align-items: center;
      justify-content: center;
      position: relative;
      font-size: 12px;
      .el-input__inner {
        height: 36px;
      }
      .el-input__suffix-inner {
        display: flex;

        flex-direction: row-reverse;
      }
    }
  }

  .search-prompt {
    position: absolute;
    display: flex;
    flex-direction: column;
    top: 50px;
    width: 270px;
    max-height: 400px;
    overflow: hidden;
    color: #000;
    background-color: #fff;
    box-shadow: 0px 2px 10px 0px rgba(171, 171, 171, 0.28);
    z-index: 999;
    padding: 0 20px;
    li {
      order: 99;
    }
    a {
      color: #000;
    }
    .result-type {
      line-height: 40px;
      height: 40px;
      color: #8f95ac;
      font-size: 12px;
    }
    .result-list {
      line-height: 40px;
      a:hover {
        color: #4272ab;
      }
      p {
        @include ellipsis();
        color: #555555;
      }

      .post-name {
        color: #8f95ac;
      }
    }
  }
  .user {
    position: relative;
    &:hover .toolBar {
      display: block;
    }
    .avatar-40 {
      width: 40px;
      height: 40px;
      margin: 7px 5px 0;
      border-radius: 20px;
      background-color: #fff;
      text-align: center;
      line-height: 40px;
      color: #4272ab;
      display: inline-block;
    }
    .avatar-60 {
      width: 60px;
      height: 60px;
      border-radius: 30px;
      background-color: #1890ff;
      text-align: center;
      line-height: 60px;
      color: #fff;
      font-size: 18px;
      margin-right: 15px;
      flex-shrink: 0;
    }
    .user-show {
      cursor: pointer;
      img {
        border-radius: 30px;
      }
      i {
        padding: 0;
        padding-left: 10px;
      }
    }
    img {
      margin: 0 5px;
    }
    .el-icon-arrow-down {
      padding: 5px;
    }
    .toolBar {
      display: none;
      position: absolute;
      top: 64px;
      right: -30px;
      width: 330px;
      height: 140.26px;
      background-color: rgba(255, 255, 255, 1);
      box-shadow: 0px 5px 8px 0px rgba(0, 0, 0, 0.1);
      color: #000;
      padding: 20px 30px;
      font-size: 12px;
      border-radius: 4px;
      z-index: 999;
      a {
        color: #000;
      }
      .user-info {
        position: relative;
        display: flex;
        height: 70px;
        img {
          width: 60px;
          height: 60px;
          margin-right: 15px;
          border-radius: 40px;
          flex-shrink: 0;
        }
        &:before {
          content: "";
          width: 0px;
          height: 0px;
          border-left: 5px solid transparent;
          border-right: 5px solid transparent;
          border-bottom: 5px solid #fff;
          position: absolute;
          top: -25px;
          right: 45px;
        }
        .user-title {
          display: flex;
          flex-direction: column;
          h3 {
            font-size: 18px;
            line-height: 24px;
            color: #333;
            left: 950px;
            font-family: PingFangSC-Regular;
          }
          p {
            line-height: 16px;
            color: #666;
            font-family: PingFangSC-Regular;
          }
        }
      }
      .operation-list {
        display: flex;
        justify-content: space-between;
        padding: 0 10px;
        a {
          cursor: pointer;
          &:hover {
            color: #1890ff;
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">
.home-header {
  .search-container {
    .el-input__suffix {
      top: 8px;
    }
    .el-input {
      width: 270px;
      .el-icon-search {
        font-size: 16px;
        margin-top: 2px;
        cursor: pointer;
      }
      .el-input__inner {
        height: 28px;
        line-height: 28px;
        margin-top: -4px;
        padding-right: 48px;
      }

      .el-icon-circle-close:before {
        content: "\e79d";
        color: #999999;
      }
    }
  }
}
</style>
